
export function handleSubmit(event) {
    event.preventDefault();
    const config = JSON.parse($form.dataset.config);
    const form_data = new FormData(event.target);
    console.log({ config });
    for (const entry of form_data.entries()) {
        console.log(entry);
    }
    const request_body = Object.fromEntries(form_data);
    request_body.meta = config.meta;
    fetch(config.form.action, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request_body)
    })
        .then(result => result.json())
        .then(resolve)
        .catch(reject);
}

export function createForm($form) {
    return new Promise((resolve, reject) => {
        $form.addEventListener('submit', event => {
            event.preventDefault();
            const config = JSON.parse($form.dataset.config);
            const form_data = new FormData(event.target);
            console.log({ config });
            for (const entry of form_data.entries()) {
                console.log(entry);
            }
            const request_body = Object.fromEntries(form_data);
            request_body.meta = config.meta;
            fetch(config.form.action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request_body)
            })
                .then(result => result.json())
                .then(resolve)
                .catch(reject);
        });
    });
}